import React from 'react';
import { Link } from 'react-router-dom';
import { Lock } from 'lucide-react';

interface LoginToBuyProps {
  /** 'compact' = badge inline (lista prodotti)
   *  'cta'     = bottone full-width (pagina dettaglio, area carrello) */
  variant?: 'compact' | 'cta';
}

export function LoginToBuy({ variant = 'compact' }: LoginToBuyProps) {
  if (variant === 'cta') {
    return (
      <Link
        to="/accedi"
        className="w-full h-11 rounded-lg text-sm font-medium flex items-center justify-center gap-2 bg-[hsl(214,58%,41%)] text-white hover:bg-[hsl(214,58%,46%)] transition-colors"
        data-testid="login-to-buy-cta"
      >
        <Lock className="w-4 h-4" />
        Accedi per acquistare
      </Link>
    );
  }

  return (
    <Link
      to="/accedi"
      className="inline-flex items-center gap-1 text-[11px] font-medium text-[hsl(214,58%,41%)] hover:underline whitespace-nowrap"
      data-testid="login-to-buy-compact"
    >
      <Lock className="w-3 h-3 shrink-0" />
      Accedi
    </Link>
  );
}
